// extracted by mini-css-extract-plugin
export default {"content":"JobPostSuccess_content__L0Ru5","quoteWrap":"JobPostSuccess_quoteWrap__sfghh","msg":"JobPostSuccess_msg__Hgigh","blogWrap":"JobPostSuccess_blogWrap__EeOSA"};